import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 * Facets component
 */
export default class Search extends Base {
  timeout = null;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Search',
    refs: ['overlay', 'form', 'input', 'close', 'parentContainer', 'container', 'loader'],
  };

  /**
   * Set Default container
   * @returns {void}
   */
  mounted() {
    this.defaultContainer = this.$refs.container.innerHTML;
  }

  onOverlayClick() {
    this.close();
  }

  /**
   * Get input value
   * @returns {string} current value.
   */
  get searchTerm() {
    return this.$refs.input.value;
  }

  /**
   * Perform search when typing something in input
   * @returns {void}
   */
  onInputInput() {
    this.$refs.loader.style.display = 'block';

    clearTimeout(this.timeout);

    if (!this.searchTerm) {
      this.$refs.loader.style.display = 'none';
      this.$refs.container.innerHTML = this.defaultContainer;
      return;
    }

    this.timeout = setTimeout(() => {
      fetch(
        `${window.theme.routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&section_id=predictive-search&resources[type]=product`,
      )
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderResults(results);
        })
        .catch((error) => {
          if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          throw error;
        });
    }, 800);
  }

  /**
   * Set results to the page
   * @param  {HTML} results products results
   * @returns {void}
   */
  renderResults(results) {
    this.$refs.loader.style.display = 'none';
    this.$refs.container.innerHTML = results;
  }

  /**
   * Open Search
   * @returns {void}
   */
  open() {
    addClass(document.documentElement, ['overflow-hidden', 'is-search-open']);
    removeClass(this.$refs.overlay, ['opacity-0', 'pointer-events-none']);
    removeClass(this.$refs.parentContainer, ['translate-x-[450px]', 'pointer-events-none']);
    this.$refs.input.focus();
  }

  /**
   * Close search
   * @returns {void}
   */
  close() {
    removeClass(document.documentElement, ['overflow-hidden', 'is-search-open']);
    addClass(this.$refs.parentContainer, ['translate-x-[450px]', 'pointer-events-none']);
    addClass(this.$refs.overlay, ['opacity-0', 'pointer-events-none']);
    this.$refs.input.value = '';
    this.$refs.container.innerHTML = this.defaultContainer;
  }

  /**
   * Click on close btn
   * @returns {void}
   */
  onCloseClick() {
    this.close();
  }

  /**
   * Close panel when type on Escape key
   * @param {object} props Props
   * @param {object} props.ESC Escape key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.close();
    }
  }
}
